<p-confirmDialog [dismissableMask]="true"></p-confirmDialog>

<!-- Toast notifications only while authenticated -->
<div
  *ngIf="isLoggedIn()"
  class="toaster-container d-flex align-items-center justify-content-center"
>
  <div class="w-50">
    <div
      *ngFor="let notification of notifications"
      [ngClass]="notification.type"
      class="my-3 w-100 toaster"
    >
      <h5 class="col-10">
        {{ notification.message }}
      </h5>
      <div class="col-2 d-flex align-items-center justify-content-end">
        <button
          mat-icon-button
          class="btn_icon"
          (click)="removeNotification(notification)"
        >
          <i class="ri-close-circle-line"></i>
        </button>
      </div>
    </div>
  </div>
</div>

<!--
  One router-outlet stays mounted for guest and logged-in shells.
  Swapping outlets with *ngIf after login left /dashboard attached to a
  destroyed guest outlet (TAL-1461: blank screen until refresh).
-->
<div [ngClass]="showAppChrome ? 'layout-wrapper' : 'guest-content'">
  <div
    *ngIf="showAppChrome"
    class="sidebar-container"
    [ngClass]="{ collapsed: sidebarCollapsed, rtl: isRtl }"
  >
    <app-menu
      [sidebarCollapsed]="sidebarCollapsed"
      [isRtl]="isRtl"
      (collapseSidebar)="toggleSidebar()"
    ></app-menu>
  </div>

  <div
    [class.content-container]="showAppChrome"
    [ngClass]="{ rtl: showAppChrome && isRtl }"
  >
    <ngx-spinner
      *ngIf="showAppChrome"
      class="main-content-spinner"
      name="main"
      bdColor="rgba(0, 0, 0, 0.65)"
      [fullScreen]="true"
      [template]="talLoadingSpinnerTemplate"
    ></ngx-spinner>
    <ngx-spinner
      *ngIf="!showAppChrome"
      name="guest"
      bdColor="rgba(0, 0, 0, 0.65)"
      [fullScreen]="true"
      [template]="talLoadingSpinnerTemplate"
    ></ngx-spinner>
    <app-nav *ngIf="showAppChrome" class="top-navbar" [isRtl]="isRtl"></app-nav>
    <div [class.main-content]="showAppChrome">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
